module.exports = __webpack_public_path__ + "static/media/agent-app-extension.78d5975c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intros/agent-app-extension.png
// module id = 962
// module chunks = 0